<script>
    import Textfield, {Input, Textarea} from '@smui/textfield';
    import Card from '@smui/card';
    import {registeredUser, userValidation, registerPageState} from './registeredUser.js'
    import Button, {Group, Label} from '@smui/button';
    import ContactFooter from "../common/contact/ContactFooter.svelte";

    let nameDirty = false;
    let lastNameDirty = false;
    let emailDirty = false;
    let phoneNumberDirty = false;

</script>
<div class="container-fluid mb-3">
    <div class="row justify-content-center">
        <div class="col-12 col-md-8 col-lg-6 col-xl-4">
            <Card>
                <div class="cng-card__primary">
                    <div class="mdc-typography--headline5">Aanvrager</div>
                </div>
                <div class="cng-card__divider"></div>
                <div class="cng-card__secondary">
                    <p>
                        Vul hier de gegevens in van de contactpersoon die de We-ID Enterprise aanvraag doorloopt.
                    </p>
                </div>
                <div class="cng-card__secondary">
                    <div class="mb-3">
                        <Textfield variant="outlined"
                                   bind:dirty="{nameDirty}"
                                   invalid={nameDirty && !$userValidation.nameResult.valid}
                                   bind:value={$registeredUser.name}
                                   label="Voornaam*"/>
                    </div>
                    <div class="mb-3">
                        <Textfield variant="outlined"
                                   bind:value={$registeredUser.initial}
                                   label="Tussenvoegsel"/>
                    </div>
                    <div class="mb-3">
                        <Textfield variant="outlined"
                                   bind:dirty="{lastNameDirty}"
                                   invalid={lastNameDirty && !$userValidation.lastNameResult.valid}
                                   bind:value={$registeredUser.lastName}
                                   label="Achternaam*"/>
                    </div>
                    <div class="mb-3">
                        <Textfield variant="outlined"
                                   bind:dirty="{emailDirty}"
                                   invalid={emailDirty && !$userValidation.emailResult.valid}
                                   bind:value={$registeredUser.email}
                                   label="Email*"/>
                    </div>
                    <div class="mb-3">
                        <Textfield variant="outlined"
                                   bind:dirty="{phoneNumberDirty}"
                                   invalid={phoneNumberDirty && !$userValidation.phoneNumberResult.valid}
                                   bind:value={$registeredUser.phoneNumber}
                                   label="Telefoonnummer*"/>
                    </div>
                </div>
                <div class="mdc-card__actions cng-card__actions-align-end">
                    <div class="mdc-card__action-buttons">
                        {#if $registerPageState}
                            <Button href="#/organizations"><Label>Verder</Label></Button>
                        {:else}
                            <Button class="navigation-button" disabled><Label>verder</Label></Button>
                        {/if}
                    </div>
                </div>
                <ContactFooter/>
            </Card>
        </div>
    </div>
</div>
